import { Component, OnInit, OnDestroy } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

// 1. Interface for Fun Facts
export interface FactItem {
  value: string;
  label: string;
  delay: string;
}

// 2. Interface for Carousel Slides
export interface SlideItem {
  title: string;
  subtitle: string;
  paragraph: string;
  image: string;
}

// 3. Interface for Service Items
export interface ServiceItem {
  icon: string;
  title: string;
  description: string;
  link: string;
  delay: string;
}

// 4. Interface for Project Items
export interface ProjectItem {
  image: string;
  title: string;
  category: string;
  link: string;
  delay: string;
}

// 5. Interface for Blog Items
export interface BlogItem {
  blogImage: string;
  category: string;
  link: string;
  authorImage: string;
  authorName: string;
  date: string;
  summary: string;
  shares: string;
  comments: string;
  delay: string;
}

// 6. Interface for Team Members
export interface TeamMember {
  id: string;
  name: string;
  designation: string;
  image: string;
  facebook?: string;
  twitter?: string;
  instagram?: string;
  linkedin?: string;
}

// 7. Interface for Testimonials
export interface TestimonialItem {
  id: string;
  name: string;
  profession: string;
  image: string;
  rating: number;
  comment: string;
}

// 8. Interface for Contact Information Items
export interface ContactInfoItem {
  icon: string;
  title: string;
  value: string;
  link: string;
  delay: string;
}


@Component({
  standalone: false,
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrl: './home-one.component.css'
})
export class HomeOneComponent implements OnInit, OnDestroy {
  
  // Owl Slider Options
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin: 0,
    nav: true,
    autoplay: true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
  };

  // Carousel Slides Array
  slideStore: SlideItem[] = [
    {
      title: "Build Powerful Brand Identity with Us",
      subtitle: "Creative Branding",
      paragraph: "We craft stunning visuals and digital experiences that connect brands with their audiences like never before.",
      image: "assets/images/carousel-1.jpg"
    },
    {
      title: "Transforming Ideas into Visual Masterpieces",
      subtitle: "Creative Solutions",
      paragraph: "From concept to creation, we design digital products that inspire and elevate your brand story.",
      image: "assets/images/carousel-2.jpg"
    }
  ];

  // Fun Facts Data Array
  facts: FactItem[] = [
    {
      value: '99',
      label: 'Success in getting happy customer',
      delay: '.1s'
    },
    {
      value: '25',
      label: 'Thousands of successful business',
      delay: '.3s'
    },
    {
      value: '120',
      label: 'Total clients who love HighTech',
      delay: '.5s'
    },
    {
      value: '5',
      label: 'Stars reviews given by satisfied clients',
      delay: '.7s'
    }
  ];

  // Lifecycle Hooks
  ngOnInit(): void {
    // Initialization code (if any)
  }

  ngOnDestroy(): void {
    // Cleanup code (if any)
  }

  // Services Data Array
  services: ServiceItem[] = [
    {
      icon: 'bi bi-boxes',
      title: 'Web Design',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.3s'
    },
    {
      icon: 'bi bi-brilliance',
      title: 'Web Development',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.5s'
    },
    {
      icon: 'bi bi-brush-fill',
      title: 'UI/UX Design',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.7s'
    },
    {
      icon: 'bi bi-bullseye',
      title: '3d Animation',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.3s'
    },
    {
      icon: 'bi bi-circle-square',
      title: 'Digital Marketing',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.5s'
    },
    {
      icon: 'bi bi-code-slash',
      title: 'Programming',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.7s'
    }
  ];

  // Projects Data Array
  projects: ProjectItem[] = [
    {
      image: 'assets/images/project-1.jpg',
      title: 'UI/UX Design',
      category: 'Web Analysis',
      link: '/portfolio',
      delay: '.3s'
    },
    {
      image: 'assets/images/project-2.jpg',
      title: 'App Development',
      category: 'Cyber Security Core',
      link: '/portfolio',
      delay: '.5s'
    },
    {
      image: 'assets/images/project-3.jpg',
      title: 'Responsive',
      category: 'Upcomming Phone',
      link: '/portfolio',
      delay: '.7s'
    },
    {
      image: 'assets/images/project-4.jpg',
      title: 'Angular',
      category: 'Web Analysis',
      link: '/portfolio',
      delay: '.3s'
    },
    {
      image: 'assets/images/project-5.jpg',
      title: 'Digital Marketing',
      category: 'Marketing Analysis',
      link: '/portfolio',
      delay: '.5s'
    },
    {
      image: 'assets/images/project-6.jpg',
      title: '24/7 Support',
      category: 'keyword Analysis',
      link: '/portfolio',
      delay: '.7s'
    }
  ];

  // Blog Posts Data Array
  blogs: BlogItem[] = [
    {
      blogImage: 'assets/images/blog-1.jpg',
      category: 'Web Design',
      link: '/blog-grid',
      authorImage: 'assets/images/admin.jpg',
      authorName: 'Morris Jeff',
      date: '24 March 2025',
      summary: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt libero sit amet',
      shares: '5324',
      comments: '5',
      delay: '.3s'
    },
    {
      blogImage: 'assets/images/blog-2.jpg',
      category: 'Development',
      link: '/blog-grid',
      authorImage: 'assets/images/admin-2.jpg',
      authorName: 'Sofia Doe',
      date: '23 April 2024',
      summary: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt libero sit amet',
      shares: '5324',
      comments: '5',
      delay: '.5s'
    },
    {
      blogImage: 'assets/images/blog-3.jpg',
      category: 'Mobile App',
      link: '/blog-grid',
      authorImage: 'assets/images/admin-3.jpg',
      authorName: 'Alex Doe',
      date: '30 Jan 2025',
      summary: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt libero sit amet',
      shares: '5324',
      comments: '5',
      delay: '.7s'
    }
  ];

  // Responsive Owl Carousel Options for Team Slider
  customOptionsTwo: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    margin: 25,
    navSpeed: 700,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 3
      },
      768: {
        items: 3
      },
      992: {
        items: 3
      }
    },
    nav: true
  };

  // Dynamic Team Members Array
  teamStore: TeamMember[] = [
    {
      id: 'team-1',
      name: 'Eric Cantona',
      designation: 'CEO / Founder',
      image: 'assets/images/team-1.jpg',
      facebook: '#.',
      twitter: '#.',
      instagram: '#.',
      linkedin: '#.'
    },
    {
      id: 'team-2',
      name: 'Sofia Doe',
      designation: 'Project Manager',
      image: 'assets/images/team-2.jpg',
      facebook: '#.',
      twitter: '#.',
      instagram: '#.',
      linkedin: '#.'
    },
    {
      id: 'team-3',
      name: 'Alex Jeff',
      designation: 'UI/UX Designer',
      image: 'assets/images/team-3.jpg',
      facebook: '#.',
      twitter: '#.',
      instagram: '#.',
      linkedin: '#.'
    },
    {
      id: 'team-4',
      name: 'Morris Jeff',
      designation: 'Web Developer',
      image: 'assets/images/team-4.jpg',
      facebook: '#.',
      twitter: '#.',
      instagram: '#.',
      linkedin: '#.'
    }
  ];

  // Testimonial Owl Carousel Configuration
  customOptionsThree: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    dots: true,
    margin: 0,
    nav: false,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 3
      },
      768: {
        items: 2
      },
      992: {
        items: 3
      }
    }
  };

  // Testimonials Data Array
  testimonials: TestimonialItem[] = [
    {
      id: 'test-1',
      name: 'Luke Oliver',
      profession: 'Marketing Lead',
      image: 'assets/images/testimonial-1.jpg',
      rating: 5,
      comment: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum aliquam dolor eget urna. Nam volutpat libero sit amet leo cursus, ac viverra eros morbi quis quam mi.'
    },
    {
      id: 'test-2',
      name: 'Emma Doe',
      profession: 'Designer',
      image: 'assets/images/testimonial-2.jpg',
      rating: 5,
      comment: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum aliquam dolor eget urna. Nam volutpat libero sit amet leo cursus, ac viverra eros morbi quis quam mi.'
    },
    {
      id: 'test-3',
      name: 'Johnathan Doe',
      profession: 'App Developer',
      image: 'assets/images/testimonial-3.jpg',
      rating: 5,
      comment: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum aliquam dolor eget urna. Nam volutpat libero sit amet leo cursus, ac viverra eros morbi quis quam mi.'
    },
    {
      id: 'test-4',
      name: 'Ammy Doe',
      profession: 'UI/UX Designer',
      image: 'assets/images/testimonial-4.jpg',
      rating: 5,
      comment: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum aliquam dolor eget urna. Nam volutpat libero sit amet leo cursus, ac viverra eros morbi quis quam mi.'
    }
  ];

  // Helper method to render stars dynamically
  getStars(rating: number): number[] {
    return Array(rating).fill(0);
  }


  // Contact Info Cards Data
  contactDetails: ContactInfoItem[] = [
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Address',
      value: '23 rank Str, NY',
      link: 'https://goo.gl/maps/Zd4BCynmTb98ivUJ6',
      delay: '.3s'
    },
    {
      icon: 'fa fa-phone',
      title: 'Call Us',
      value: '+012 3456 7890',
      link: 'tel:+0123456789',
      delay: '.5s'
    },
    {
      icon: 'fa fa-envelope',
      title: 'Email Us',
      value: 'info@example.com',
      link: 'mailto:info@example.com',
      delay: '.7s'
    }
  ];

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }
  // Contact Form End
}